import React from 'react';

import { CpcSliderContext } from './FeedEntryCpcViewer';
import YouTubeCustomPlayer from './YouTubeCustomPlayer';

const YouTubeEmbed = React.memo(
  (props: {
    ytVideoId: string;
    duration?: number;
    portrait?: boolean;
    maxHeightShort?: boolean;
    parentSlideIndex?: number;
  }) => {
    const cpcSliderContext = React.useContext(CpcSliderContext);
    return (
      <div className="tw-flex tw-justify-center">
        <YouTubeCustomPlayer
          ytVideoId={props.ytVideoId}
          recordStoryOpen={() => null}
          portrait={props.portrait}
          forceNoAutoPlay
          focusPlay={cpcSliderContext.slideIndex === props.parentSlideIndex}
          onEnd={cpcSliderContext.nextSlide}
          maxHeightShort={props.maxHeightShort}
        />
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.ytVideoId === nextProps.ytVideoId &&
    prevProps.duration === nextProps.duration &&
    prevProps.portrait === nextProps.portrait &&
    prevProps.maxHeightShort === nextProps.maxHeightShort &&
    prevProps.parentSlideIndex === nextProps.parentSlideIndex,
);

export default YouTubeEmbed;
